export default {
  // Campaigns
  campaigns: {
    title: 'แคมเปญรางวัล',
    subtitle: 'จัดการแคมเปญความภักดีและรางวัลสำหรับผู้เช่า',
    new_button: 'แคมเปญใหม่',
    status: {
      draft: 'แบบร่าง',
      active: 'ใช้งาน',
      paused: 'หยุดชั่วคราว',
      closed: 'ปิดแล้ว',
    },
    earn_model: {
      stamp: 'สะสมแสตมป์',
      points: 'สะสมแต้ม',
      instant: 'รางวัลทันที',
    },
    fields: {
      name: 'ชื่อแคมเปญ',
      description: 'คำอธิบาย',
      earn_model: 'รูปแบบการสะสม',
      status: 'สถานะ',
      property: 'อสังหาริมทรัพย์',
      pool_remaining: 'วงเงินคงเหลือ',
      pool_total: 'วงเงินทั้งหมด',
      partner_shops_count: 'ร้านค้าพาร์ทเนอร์',
      catalog_items_count: 'รายการรางวัล',
      starts_at: 'เริ่มต้น',
      ends_at: 'สิ้นสุด',
      published_at: 'เผยแพร่เมื่อ',
    },
    publish_panel: {
      title: 'เผยแพร่และเติมวงเงินแคมเปญ',
      description: 'เติมเงินในกองทุนรางวัลและเปิดใช้งานแคมเปญนี้',
      funded_amount: 'จำนวนเงินที่เติม (บาท)',
      subsidy_amount: 'จำนวนเงินอุดหนุน (บาท)',
      starts_at: 'วันเริ่มต้นแคมเปญ',
      ends_at: 'วันสิ้นสุดแคมเปญ',
      publish_button: 'เผยแพร่และเติมวงเงิน',
      pool_info: 'กองทุน: {{remaining}} / {{total}} บาทคงเหลือ',
    },
    form: {
      save_button: 'บันทึกแคมเปญ',
      create_success: 'สร้างแคมเปญแล้ว',
      update_success: 'อัปเดตแคมเปญแล้ว',
      publish_success: 'เผยแพร่และเติมวงเงินแคมเปญแล้ว',
      delete_confirm: 'ลบแคมเปญนี้? ไม่สามารถย้อนกลับได้',
      delete_success: 'ลบแคมเปญแล้ว',
    },
    empty: {
      title: 'ยังไม่มีแคมเปญ',
      description: 'สร้างแคมเปญรางวัลเพื่อเริ่มสร้างความผูกพันกับผู้เช่า',
    },
  },

  // Partner Shops
  partner_shops: {
    title: 'ร้านค้าพาร์ทเนอร์',
    new_button: 'เพิ่มร้านค้า',
    fields: {
      name: 'ชื่อร้านค้า',
      contact_name: 'ชื่อผู้ติดต่อ',
      phone: 'โทรศัพท์',
      tax_id: 'เลขประจำตัวผู้เสียภาษี',
      address: 'ที่อยู่',
      status: 'สถานะ',
      devices: 'อุปกรณ์',
      last_used_at: 'ใช้งานล่าสุด',
      session_expires_at: 'เซสชันหมดอายุ',
    },
    actions: {
      revoke: 'ยกเลิกเซสชัน',
      rotate: 'หมุนเวียนโทเค็น',
      revoke_confirm: 'ยกเลิกเซสชันอุปกรณ์ที่ใช้งานอยู่ของร้านค้านี้?',
      revoke_success: 'ยกเลิกเซสชันแล้ว',
      rotate_success: 'หมุนเวียนโทเค็นแล้ว',
    },
    token_panel: {
      title: 'โทเค็นเซสชันใหม่',
      description: 'คัดลอกโทเค็นนี้ทันที จะไม่แสดงอีกครั้ง',
      device_label: 'ชื่ออุปกรณ์',
    },
    form: {
      save_button: 'บันทึกร้านค้า',
      create_success: 'เพิ่มร้านค้าแล้ว',
      update_success: 'อัปเดตร้านค้าแล้ว',
      delete_confirm: 'ลบร้านค้านี้? ไม่สามารถย้อนกลับได้',
      delete_success: 'ลบร้านค้าแล้ว',
    },
    empty: {
      title: 'ยังไม่มีร้านค้าพาร์ทเนอร์',
      description: 'เพิ่มร้านค้าพาร์ทเนอร์เข้าแคมเปญนี้',
    },
  },

  // Catalog
  catalog: {
    title: 'รายการรางวัล',
    subtitle: 'จัดการรางวัลที่แลกได้จากทุกแคมเปญ',
    new_button: 'รายการใหม่',
    reward_type: {
      partner_voucher: 'คูปองร้านค้าพาร์ทเนอร์',
      rent_credit: 'เครดิตค่าเช่า',
      flowrent_perk: 'สิทธิพิเศษ FlowRent',
      instant_discount: 'ส่วนลดทันที',
    },
    fields: {
      name: 'ชื่อรายการ',
      reward_type: 'ประเภทรางวัล',
      cost_points: 'ราคา (แต้ม)',
      thb_value: 'มูลค่า (บาท)',
      funding: 'แหล่งเงินทุน',
      stock: 'สต็อก',
      per_customer_limit: 'จำกัดต่อลูกค้า',
      active: 'ใช้งาน',
      campaign: 'แคมเปญ',
    },
    form: {
      save_button: 'บันทึกรายการ',
      create_success: 'สร้างรายการรางวัลแล้ว',
      update_success: 'อัปเดตรายการรางวัลแล้ว',
      delete_confirm: 'ลบรายการรางวัลนี้? ไม่สามารถย้อนกลับได้',
      delete_success: 'ลบรายการรางวัลแล้ว',
    },
    empty: {
      title: 'ยังไม่มีรายการรางวัล',
      description: 'เพิ่มรางวัลในรายการเพื่อให้ผู้เช่าแลกรับ',
    },
  },

  // Promotions
  promotions: {
    title: 'โปรโมชัน',
    subtitle: 'จัดการโปรโมชันส่วนลดและติดตามการใช้สิทธิ์',
    new_button: 'โปรโมชันใหม่',
    kind_label: 'ประเภท',
    value_type: {
      fixed: 'จำนวนคงที่',
      percent: 'เปอร์เซ็นต์',
    },
    fields: {
      kind: 'ประเภทโปรโมชัน',
      value_type: 'ประเภทมูลค่า',
      value: 'มูลค่า',
      currency: 'สกุลเงิน',
      funding: 'แหล่งเงินทุน',
      starts_at: 'เริ่มต้น',
      ends_at: 'สิ้นสุด',
      max_redemptions: 'จำนวนสูงสุด',
      per_customer_limit: 'จำกัดต่อลูกค้า',
      status: 'สถานะ',
      redemptions_count: 'การใช้สิทธิ์',
      conditions: 'เงื่อนไข',
      code: 'รหัสโปรโมชัน (ไม่บังคับ)',
    },
    status: {
      active: 'ใช้งาน',
      draft: 'แบบร่าง',
      paused: 'หยุดชั่วคราว',
      expired: 'หมดอายุ',
      ended: 'สิ้นสุดแล้ว',
    },
    redemptions: {
      title: 'ประวัติการใช้สิทธิ์',
      customer_id: 'รหัสลูกค้า',
      lease_id: 'รหัสสัญญาเช่า',
      invoice_id: 'รหัสใบแจ้งหนี้',
      amount: 'จำนวนเงิน',
      applied_amount: 'จำนวนที่ใช้',
      status: 'สถานะ',
      redeemed_at: 'วันที่ใช้สิทธิ์',
      empty_title: 'ยังไม่มีการใช้สิทธิ์',
      empty_description: 'การใช้สิทธิ์จะแสดงที่นี่เมื่อผู้เช่าใช้โปรโมชันนี้',
      status_values: {
        eligible: 'มีสิทธิ์',
        applied: 'ใช้แล้ว',
        void: 'ยกเลิก',
      },
    },
    form: {
      save_button: 'บันทึกโปรโมชัน',
      create_success: 'สร้างโปรโมชันแล้ว',
      update_success: 'อัปเดตโปรโมชันแล้ว',
      delete_confirm: 'ลบโปรโมชันนี้? ไม่สามารถย้อนกลับได้',
      delete_success: 'ลบโปรโมชันแล้ว',
    },
    empty: {
      title: 'ยังไม่มีโปรโมชัน',
      description: 'สร้างโปรโมชันเพื่อเสนอส่วนลดให้กับผู้เช่า',
    },
  },
}
